<style lang="scss" scoped>

</style>

<template>
    <div>
        <masonry :cols="{default: 2, 576: 1}" :gutter="30">
            <news-card v-for="(item, index) in news" :key="index" :data="item"></news-card>
        </masonry>
    </div>
</template>

<script>
export default {
    props: ['news'],
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/news-feed.vue